module.exports = __webpack_public_path__ + "static/media/S2N2-3.04c969de.svg";